import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { FormGroup, Input } from 'reactstrap'
import Select from 'views/pages/Select'
import { CreatableSelect } from 'views/pages/Select'

function CreateJobInput({
  id,
  label,
  name = '',
  placeholder = '',
  type = 'text',
  required = false,
  fullSize = false,
  visibility = 'visible',
  select = false,
  selectedOptions = [],
  options = [],
  defaultValue = '',
  value = undefined,
  onChange = () => {},
  disabled = false,
  creatable = false,
  createFn = () => {},
  display = '',
  rows = 3,
  onFocus = () => {},
  onBlur = () => {},
  customClassName = '',
}) {
  const { submittedForm } = useSelector((store) => store.recruitment)

  return (
    <FormGroup
      className={`ml-0 create-job-input ${display} ${
        fullSize ? 'full-size' : ''
      } ${visibility} ${customClassName} ${
        required
          ? submittedForm
            ? select &&
              (selectedOptions?.length ||
                selectedOptions?.value ||
                selectedOptions?.name)
              ? `submitted-filled`
              : `submitted-empty`
            : ''
          : ''
      }`}
    >
      <label className='form-control-label' htmlFor={`field-${id}`}>
        {label} {required && <span className='text-danger'>*</span>}
      </label>
      {!select ? (
        <div className='position-relative'>
          <Input
            id={`field-${id}`}
            name={name}
            type={type}
            placeholder={placeholder}
            onChange={(e) => {
              if (type === 'file') {
                onChange(e.target.files[0])
                return
              }
              onChange(e.target.value, required, name)
            }}
            onFocus={onFocus}
            onBlur={onBlur}
            value={value !== undefined ? value : undefined}
            defaultValue={value === undefined ? defaultValue : undefined}
            className={`${
              required
                ? submittedForm && !(value !== undefined ? value : defaultValue)
                  ? 'border-danger'
                  : submittedForm &&
                    (value !== undefined ? value : defaultValue)
                  ? 'border-success'
                  : ''
                : ''
            }`}
            disabled={disabled}
            min={0}
            rows={rows}
          />
          {submittedForm && required && type !== 'date' && (
            <FontAwesomeIcon
              icon={!defaultValue ? faXmark : faCheck}
              size='lg'
              className={`${
                !defaultValue ? 'text-danger' : 'text-success'
              } position-absolute`}
              style={{ right: 15, bottom: 12 }}
            />
          )}
        </div>
      ) : (
        <>
          {!creatable ? (
            <Select
              options={options}
              // selectedOptions={language || user.language}
              onChange={(option) => {
                onChange(option, name)
              }}
              valueKey={id}
              multi={false}
              placeholder={placeholder}
              selectedOptions={selectedOptions}
            />
          ) : (
            <CreatableSelect
              options={options}
              selectedOptions={
                selectedOptions && selectedOptions.length
                  ? selectedOptions.map((el) => el.option)
                  : []
              }
              onChange={(option) => {
                const lastOption = Array.isArray(option)
                  ? option[option.length - 1]
                  : option

                const finalNewOption = lastOption?.__isNew__
                  ? {
                      name: lastOption.value,
                      value: lastOption.value,
                      label: lastOption.value,
                      option: { name: lastOption.value },
                    }
                  : option

                onChange(finalNewOption, name)

                if (lastOption?.__isNew__) {
                  createFn([lastOption])
                }
              }}
              placeholder={placeholder}
            />
          )}
        </>
      )}
    </FormGroup>
  )
}

export default CreateJobInput
